var staticStrLast = 'last'

module.exports = staticStrLast



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/staticStrLast.js
// module id = 227
// module chunks = 75